// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*----------------head------------------*/
.head {
  padding: 12px 0;
  color: #edf2f7;
  display: flex;
  align-items: center;
}
.search {
  background: #3b4455;
  padding: 12px 20px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.search:hover {
  transform: scale(1.02);
}
.iconHead {
  margin-left: 15px;
  margin-right: 15px;
  color: #edf2f7;
  transition: transform 0.2s ease;
}
.iconHead:hover {
  transform: scale(1.1);
}
.head .imageCircle {
  margin-right: 12px;
}
.profile .iconHead {
  margin-left: 12px;
  margin-right: 0;
}
.search .iconHead {
  margin: 0 8px 0 0;
}
input::placeholder {
  color: #b0b8ca;
  font-weight: 400;
  transition: opacity 0.3s ease;
}
input:focus::placeholder {
  opacity: 0.7;
}

/*----------------header------------------*/
header {
  background: #2d3748;
  padding: 16px 0;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.link {
  display: flex;
  align-items: center;
  gap: 24px;
}
header ul li {
  display: flex;
  align-items: center;
}
header ul li a {
  color: #edf2f7;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  transition: color 0.3s ease, background-color 0.3s ease, transform 0.2s ease;
}
header ul li a:hover,
header ul li a.active {
  color: #60a5fa;
  background-color: rgba(96, 165, 250, 0.15);
  transform: translateY(-2px);
}
header ul li:hover .navIcon,
header ul li .navIcon.active {
  color: #60a5fa;
  transform: scale(1.1);
}
.navIcon {
  margin-right: 8px;
  color: #edf2f7;
  font-size: 20px !important;
  transition: color 0.3s ease, transform 0.2s ease;
}
.toggle {
  display: none;
  color: #edf2f7;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  transition: color 0.3s ease, transform 0.2s ease;
}
.toggle:hover {
  transform: scale(1.15);
}

/*----------------header------------------*/
@media only screen and (max-width: 768px) {
  .link {
    display: none;
  }
  .search {
    display: none;
  }
  .navMenu-list {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #2d3748;
    width: 70%;
    height: 100vh;
    z-index: 9999;
    padding-top: 60px;
    box-shadow: 4px 0 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, opacity 0.3s ease;
    transform: translateX(0);
    opacity: 1;
  }
  .navMenu-list:not(.active) {
    transform: translateX(-100%);
    opacity: 0;
  }
  header ul li {
    align-items: flex-start;
    margin-top: 20px;
    padding: 0 24px;
  }
  header ul li a {
    font-size: 18px;
    padding: 12px 16px;
    transition: color 0.3s ease, background-color 0.3s ease, transform 0.2s ease;
  }
  header ul li a:hover,
  header ul li a.active {
    transform: translateX(5px);
  }
  .toggle {
    display: block;
    position: fixed;
    top: 20px;
    right: 20px;
    margin: 0;
    z-index: 10000;
  }
}
/* Back button styles */
header ul li a .back-icon {
  margin-right: 8px;
  color: #edf2f7;
  font-size: 20px !important;
  transition: color 0.3s ease, transform 0.2s ease;
}

header ul li a:hover .back-icon,
header ul li a.active .back-icon {
  color: #60a5fa;
  transform: scale(1.1);
}

/* Make back button slightly different to distinguish it */
header ul li:first-child a {
  background-color: rgba(74, 85, 104, 0.3);
}

header ul li:first-child a:hover {
  background-color: rgba(96, 165, 250, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2DAA2D;AAC7D;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,4EAA4E;AAC9E;AACA;;EAEE,cAAc;EACd,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,wCAAwC;IACxC,kDAAkD;IAClD,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,4EAA4E;EAC9E;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,WAAW;IACX,SAAS;IACT,cAAc;EAChB;AACF;AACA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/*----------------head------------------*/\n.head {\n  padding: 12px 0;\n  color: #edf2f7;\n  display: flex;\n  align-items: center;\n}\n.search {\n  background: #3b4455;\n  padding: 12px 20px;\n  border-radius: 25px;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n.search:hover {\n  transform: scale(1.02);\n}\n.iconHead {\n  margin-left: 15px;\n  margin-right: 15px;\n  color: #edf2f7;\n  transition: transform 0.2s ease;\n}\n.iconHead:hover {\n  transform: scale(1.1);\n}\n.head .imageCircle {\n  margin-right: 12px;\n}\n.profile .iconHead {\n  margin-left: 12px;\n  margin-right: 0;\n}\n.search .iconHead {\n  margin: 0 8px 0 0;\n}\ninput::placeholder {\n  color: #b0b8ca;\n  font-weight: 400;\n  transition: opacity 0.3s ease;\n}\ninput:focus::placeholder {\n  opacity: 0.7;\n}\n\n/*----------------header------------------*/\nheader {\n  background: #2d3748;\n  padding: 16px 0;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.link {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\nheader ul li {\n  display: flex;\n  align-items: center;\n}\nheader ul li a {\n  color: #edf2f7;\n  font-size: 16px;\n  font-weight: 500;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: color 0.3s ease, background-color 0.3s ease, transform 0.2s ease;\n}\nheader ul li a:hover,\nheader ul li a.active {\n  color: #60a5fa;\n  background-color: rgba(96, 165, 250, 0.15);\n  transform: translateY(-2px);\n}\nheader ul li:hover .navIcon,\nheader ul li .navIcon.active {\n  color: #60a5fa;\n  transform: scale(1.1);\n}\n.navIcon {\n  margin-right: 8px;\n  color: #edf2f7;\n  font-size: 20px !important;\n  transition: color 0.3s ease, transform 0.2s ease;\n}\n.toggle {\n  display: none;\n  color: #edf2f7;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  transition: color 0.3s ease, transform 0.2s ease;\n}\n.toggle:hover {\n  transform: scale(1.15);\n}\n\n/*----------------header------------------*/\n@media only screen and (max-width: 768px) {\n  .link {\n    display: none;\n  }\n  .search {\n    display: none;\n  }\n  .navMenu-list {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background-color: #2d3748;\n    width: 70%;\n    height: 100vh;\n    z-index: 9999;\n    padding-top: 60px;\n    box-shadow: 4px 0 8px rgba(0, 0, 0, 0.2);\n    transition: transform 0.3s ease, opacity 0.3s ease;\n    transform: translateX(0);\n    opacity: 1;\n  }\n  .navMenu-list:not(.active) {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  header ul li {\n    align-items: flex-start;\n    margin-top: 20px;\n    padding: 0 24px;\n  }\n  header ul li a {\n    font-size: 18px;\n    padding: 12px 16px;\n    transition: color 0.3s ease, background-color 0.3s ease, transform 0.2s ease;\n  }\n  header ul li a:hover,\n  header ul li a.active {\n    transform: translateX(5px);\n  }\n  .toggle {\n    display: block;\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    margin: 0;\n    z-index: 10000;\n  }\n}\n/* Back button styles */\nheader ul li a .back-icon {\n  margin-right: 8px;\n  color: #edf2f7;\n  font-size: 20px !important;\n  transition: color 0.3s ease, transform 0.2s ease;\n}\n\nheader ul li a:hover .back-icon,\nheader ul li a.active .back-icon {\n  color: #60a5fa;\n  transform: scale(1.1);\n}\n\n/* Make back button slightly different to distinguish it */\nheader ul li:first-child a {\n  background-color: rgba(74, 85, 104, 0.3);\n}\n\nheader ul li:first-child a:hover {\n  background-color: rgba(96, 165, 250, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
